import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import ToastContainer from '../ui/Toast';
import { useIframeAuth } from '../../hooks/useIframeAuth';
import { isEmbedded } from '../../utils/iframe';
import { selectAuth } from '../../store/slices/authSlice';
import { Icon } from '../ui/Icon';

// ---------------------------------------------------------------------------
// Token yok / geçersiz — bloke ekranı
// ---------------------------------------------------------------------------
function AuthBlockedScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="max-w-sm w-full mx-4 text-center">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-red-100 mb-4">
          <Icon name="lock" className="h-7 w-7 text-red-600" />
        </div>
        <h1 className="text-lg font-semibold text-neutral-900 mb-1">
          Erişim Reddedildi
        </h1>
        <p className="text-sm text-neutral-500">
          Oturum bulunamadı veya süresi doldu. Tekrar giriş yapın.
        </p>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Ana layout
// ---------------------------------------------------------------------------
export default function MainLayout() {
  // iframe bridge ↔ Redux bağlantısı
  useIframeAuth();

  const auth     = useSelector(selectAuth);
  const embedded = isEmbedded();

  // ── Token guard ──────────────────────────────────────────────────────────
  // auth.token, initialState'de getStoredToken() ile sessionStorage'dan
  // synchronous okunur — ilk render'da zaten mevcut ya da null.
  // Her endpoint zaten token'ı kendi başına doğruladığı için burada
  // /me sonucunu beklemeye gerek yok; token varlığını kontrol etmek yeterli.
  // 401 gelirse apiClient interceptor'ı 'auth:expired' olayını iletir.
  if (!auth.token) {
    return (
      <>
        <AuthBlockedScreen />
        <ToastContainer />
      </>
    );
  }

  // succeeded → normal render
  // ─────────────────────────────────────────────────────────────────────────

  // Spine_app içinde çalışıyorsak kendi Sidebar/Topbar'ımızı göstermeyiz —
  // spine zaten navigasyon + kullanıcı chrome'unu sağlıyor. İçerik alanı
  // beyaz rounded-[1.25rem] kartla sarılır (diğer micro-frontend'lerle
  // aynı görsel dil).
  if (embedded) {
    return (
      <>
        <main className="px-6 pt-6 pb-8">
          <Outlet />
        </main>
        <ToastContainer />
      </>
    );
  }

  // Standalone mod — dev/QA için kendi Sidebar+Topbar'ımızı render ederiz.
  return (
    <div className="min-h-screen bg-neutral-50 flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto px-4 py-6 lg:px-8">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}
